import React, { useState } from 'react';
import { Flex } from '@tpr/core';
import { CrossButton } from '../buttons/buttons';
import Styles from './poscon.module.scss';
export var Poscon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'success.1' : _b, _c = _a.enableClose, enableClose = _c === void 0 ? false : _c, callback = _a.callback, children = _a.children;
    return enableClose ? (React.createElement(ClosablePoscon, { color: color, callback: callback }, children)) : (React.createElement(PersistentPoscon, { color: color }, children));
};
var ClosablePoscon = function (_a) {
    var color = _a.color, callback = _a.callback, children = _a.children;
    var _b = useState(false), closed = _b[0], setClosed = _b[1];
    return !closed ? (React.createElement(PersistentPoscon, { color: color, pt: 4 },
        React.createElement("div", { className: Styles.enableClose },
            React.createElement(CrossButton, { colour: 'white', onClick: function () {
                    setClosed(!closed);
                    callback && callback();
                } })),
        children)) : (React.createElement(React.Fragment, null));
};
var PersistentPoscon = function (_a) {
    var color = _a.color, _b = _a.pt, pt = _b === void 0 ? 8 : _b, children = _a.children;
    return (React.createElement(Flex, { cfg: {
            alignItems: 'center',
            justifyContent: 'center',
            bg: color,
            pb: 6,
            pt: pt,
            flexDirection: 'column',
            textAlign: 'center',
        }, role: "alert" }, children));
};
//# sourceMappingURL=poscon.js.map